import React from 'react'
import './style.scss'
import ClickStatistics from '../../../components/Affiliate/Overview/ClickStatistics'
import FinancialTransactions from '../../../components/Affiliate/FinancialTransactions'

function Overview() {
  return (
    <div className='overview'>
        <ClickStatistics />
        <FinancialTransactions />
    </div>
  )
}

export default Overview